import { UiComponentSize } from '@altibox/design-system-component-lib';
import React, { FC } from 'react';

import { IconButton, IconButtonProps } from 'src/components/icon-button';
import { chevronRightDisabledImageProps, chevronRightImageProps } from 'src/resources/images';

type Props = Omit<IconButtonProps, 'uiComponentSize' | 'icon' | 'iconBeforeText'>;

export const NavigationButton: FC<Props> = (props) => {
  const { disabled, ...rest } = props;
  const chevronIconType = disabled ? chevronRightDisabledImageProps : chevronRightImageProps;

  return (
    <IconButton
      {...rest}
      icon={chevronIconType}
      disabled={disabled}
      uiComponentSize={UiComponentSize.MEDIUM}
      iconBeforeText={false}
    />
  );
};
